var map = {
	"./ai-assistant-lg.png": 27034,
	"./ai-banner-bg.jpg": 68877,
	"./doctor-with-file.svg": 80597,
	"./heart-discount.svg": 13654,
	"./parking-sign.svg": 80167
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 62333;